<div class="row pt-5">
  <div class="col text-center">
    Processing Authentication
  </div>
</div>